import { render, staticRenderFns } from "./ExampleComponent.vue?vue&type=template&id=299e239e&"
import script from "./ExampleComponent.vue?vue&type=script&lang=js&"
export * from "./ExampleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\projetos\\escola de campeoes\\schoolmanager\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('299e239e')) {
      api.createRecord('299e239e', component.options)
    } else {
      api.reload('299e239e', component.options)
    }
    module.hot.accept("./ExampleComponent.vue?vue&type=template&id=299e239e&", function () {
      api.rerender('299e239e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ExampleComponent.vue"
export default component.exports